export default __webpack_public_path__ + "static/media/dropDownCloseIconBlack.456644d2.svg";